import './index.less';

import classNames from 'classnames';
import { ReactNode, useRef, useState } from 'react';

import IconArrow from '@/assets/icon_arrow_down.svg';
import useIslamicSubAccount from '@/hooks/useIslamicSubAccount';
import { useI18nContext } from '@/i18n/I18n';
import { useUserStore } from '@/store/useUser';
import { complianceHide } from '@/utils/complianceHelpers';
import { accountType, subAccountTypeList } from '@/utils/pageConfig/subAccount';

import Guide from '../Guide/Guide';

const AccountTab = ({
  title,
  desc,
  handler,
  showGuide: _showGuide,
  suffix,
}: {
  title: string;
  desc: string;
  handler: () => void;
  showGuide: boolean;
  suffix?: ReactNode;
}) => {
  const tabRef = useRef<HTMLDivElement>(null);
  const [showGuide, setShowGuide] = useState(_showGuide);

  const onCloseGuide = () => {
    setShowGuide(false);
  };

  return (
    <>
      <div
        ref={tabRef}
        className={classNames(
          'select-account-box',
          showGuide && 'select-account-box-show-guide',
        )}
        onClick={() => {
          handler();
        }}
      >
        <div className="select-account-box-wrapper">
          <h3 className="select-account-box-title">
            {title}
            {suffix ? suffix : null}
          </h3>
          {desc ? <p className="select-account-box-desc">{desc}</p> : null}
        </div>
        <img className="select-account-box-arrow" src={IconArrow} alt="" />
      </div>
      {showGuide && (
        <Guide
          targetSelector=".select-account-box-show-guide"
          containerSelector=".select-account-type-modal"
          onClose={onCloseGuide}
        />
      )}
    </>
  );
};

const SelectAccountType = (props: any, ref: any) => {
  const [$t] = useI18nContext();

  const { complianceConfig } = useUserStore();

  const { allowCreateIslamicSubAccount } = useIslamicSubAccount({
    pageName: 'subAccount',
  });

  return (
    <div className="create-sub-account-modal-wrapper">
      {subAccountTypeList
        .filter(({ type }) => {
          if (type === accountType.ISLAMIC) {
            return allowCreateIslamicSubAccount;
          }
          if (type === accountType.ESCROW) {
            const complianceHideEntry = complianceHide(
              complianceConfig?.TrustSubAccountCreateEntry,
            );
            return !complianceHideEntry;
          }
          return true;
        })
        .map(({ title, desc, type, showGuide }) => (
          <AccountTab
            key={type}
            title={$t(title)}
            desc={$t(desc)}
            handler={() => {
              props.setType(type);
              props.handleVisible();
            }}
            showGuide={
              props.userInfo?.id
                ? !!(showGuide?.() && !props.userInfo?.has_islamic)
                : false
            }
          />
        ))}
    </div>
  );
};

export default SelectAccountType;
